export const NATIVE_CHAIN_TOKENS = [{
  chainType: 'ethereum',
  network: 'mainnet',
  chainId: 1,
  nativeSymbol: 'eth'
}, {
  chainType: 'ethereum',
  network: 'kovan',
  chainId: 42,
  nativeSymbol: 'eth'
}, {
  chainType: 'moon',
  network: 'moonbeam',
  chainId: 1284,
  nativeSymbol: 'glmr'
}, {
  chainType: 'moon',
  network: 'moonbase-alphanet',
  chainId: 1287,
  nativeSymbol: 'dev'
}, {
  chainType: 'conflux',
  network: 'conflux eSpace',
  chainId: 1030,
  nativeSymbol: 'cfx'
}, {
  chainType: 'conflux',
  network: 'conflux eSpace Testnet',
  chainId: 71,
  nativeSymbol: 'cfx'
}, {
  chainType: 'bsc',
  network: 'bsc mainnet',
  chainId: 56,
  nativeSymbol: 'bnb'
}, {
  chainType: 'bsc',
  network: 'bsc testnet',
  chainId: 97,
  nativeSymbol: 'bnb'
}, {
  chainType: 'platon',
  network: 'platon mainnet',
  chainId: 210425,
  nativeSymbol: 'lat'
}, {
  chainType: 'platon',
  network: 'platon testnet',
  chainId: 2206132,
  nativeSymbol: 'lat'
}]
